import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fcaa1202")

_pushScopeId("data-v-fcaa1202")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Simulatore presenze")
const _hoisted_2 = { class: "page_content" }
const _hoisted_3 = { class: "container_user_info" }
const _hoisted_4 = { class: "user_avatar_container" }
const _hoisted_5 = { class: "username" }
const _hoisted_6 = { class: "single_user_info single_user_info_column" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Orari", -1)
const _hoisted_8 = {
  key: 0,
  class: "value"
}
const _hoisted_9 = {
  key: 1,
  class: "value"
}
const _hoisted_10 = { class: "single_user_info" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Stato attuale", -1)
const _hoisted_12 = { class: "value" }
const _hoisted_13 = {
  key: 0,
  class: "single_user_info"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Orario entrata", -1)
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "simulator_container" }
const _hoisted_17 = { class: "picker_container" }
const _hoisted_18 = { class: "simulator_dipendente" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", null, "Dipendente", -1)
const _hoisted_20 = { class: "selezione_reparto" }
const _hoisted_21 = { class: "simulator_dipendente" }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", null, "Data", -1)
const _hoisted_23 = { class: "selezione_reparto" }
const _hoisted_24 = { class: "simulator_entrata" }
const _hoisted_25 = /*#__PURE__*/_createVNode("p", null, "Simula entrata", -1)
const _hoisted_26 = {
  key: 0,
  class: "selezione_reparto"
}
const _hoisted_27 = { class: "simulator_entrata" }
const _hoisted_28 = /*#__PURE__*/_createVNode("p", null, "Simula uscita", -1)
const _hoisted_29 = {
  key: 0,
  class: "output_container ion-margin-top"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_select_option = _resolveComponent("ion-select-option")
  const _component_ion_select = _resolveComponent("ion-select")
  const _component_ion_datetime = _resolveComponent("ion-datetime")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start",
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, _toDisplayString($setup.user.dipendenti_nome) + " " + _toDisplayString($setup.user.dipendenti_cognome), 1)
              ]),
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                ($setup.turni.length === 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_8, " Nessun turno registrato per la giornata odierna "))
                  : (_openBlock(), _createBlock("div", _hoisted_9, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.turni, (turno, index) => {
                        return (_openBlock(), _createBlock("div", { key: index }, [
                          _createVNode("span", null, _toDisplayString($setup.printDay(turno.turni_di_lavoro_giorno)), 1),
                          _createVNode("span", null, _toDisplayString(`${turno.turni_di_lavoro_ora_inizio} - ${turno.turni_di_lavoro_ora_fine}`), 1)
                        ]))
                      }), 128))
                    ]))
              ]),
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode("div", _hoisted_12, _toDisplayString($setup.statoDipendente), 1)
              ]),
              ($setup.statoDipendente === 'Presente')
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode("div", _hoisted_15, _toDisplayString($setup.ultimaPresenza.presenze_ora_inizio), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode("div", _hoisted_20, [
                    _createVNode(_component_ion_select, {
                      name: "dipendenti",
                      interface: "action-sheet",
                      "cancel-text": "Annulla",
                      "ok-text": "Conferma",
                      modelValue: $setup.dipendenteSelezionato,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.dipendenteSelezionato = $event)),
                      placeholder: "Seleziona dipendente",
                      onIonChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.setDipendente($event.target.value)))
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.dipendenti, (dipendente) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: dipendente.dipendenti_id,
                            value: dipendente.dipendenti_id
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(dipendente.dipendenti_cognome) + " " + _toDisplayString(dipendente.dipendenti_nome), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _createVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode("div", _hoisted_23, [
                    _createVNode(_component_ion_datetime, {
                      name: "data",
                      "display-format": "DD/MM/YYYY",
                      "picker-format": "DD/MM/YYYY",
                      min: "2023",
                      max: "2099",
                      slot: "end",
                      doneText: "OK",
                      cancelText: "Annulla",
                      modelValue: $setup.data_presenza,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($setup.data_presenza = $event)),
                      placeholder: "Seleziona data"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_24, [
                _hoisted_25,
                ($setup.showSelezioneRaparti === '1')
                  ? (_openBlock(), _createBlock("div", _hoisted_26, [
                      _createVNode(_component_ion_select, {
                        name: "tipologia",
                        interface: "action-sheet",
                        "cancel-text": "Annulla",
                        "ok-text": "Conferma",
                        modelValue: $setup.repartoSelezionato,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($setup.repartoSelezionato = $event)),
                        placeholder: "Seleziona il reparto in cui timbrare",
                        onIonChange: _cache[6] || (_cache[6] = ($event: any) => ($setup.setReparto($event.target.value)))
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.reparti, (reparto) => {
                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                              key: reparto.reparti_id,
                              value: reparto.reparti_id
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(reparto.reparti_nome), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", null, [
                  _createVNode(_component_ion_datetime, {
                    name: "ora_entrata",
                    "display-format": "HH:mm",
                    "picker-format": "HH:mm",
                    slot: "end",
                    doneText: "OK",
                    cancelText: "Annulla",
                    modelValue: $setup.ora_entrata,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ($setup.ora_entrata = $event)),
                    placeholder: "Seleziona ora di entrata"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("button", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.simulaEntrata && $setup.simulaEntrata(...args))),
                  disabled: $setup.loadingSimulatorEntrata,
                  class: "btn_simula_presenza"
                }, " Entrata ", 8, ["disabled"])
              ]),
              _createVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode("div", null, [
                  _createVNode(_component_ion_datetime, {
                    name: "ora_uscita",
                    "display-format": "HH:mm",
                    "picker-format": "HH:mm",
                    slot: "end",
                    doneText: "OK",
                    cancelText: "Annulla",
                    modelValue: $setup.ora_uscita,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ($setup.ora_uscita = $event)),
                    placeholder: "Seleziona ora di uscita"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("button", {
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.simulaUscita && $setup.simulaUscita(...args))),
                  disabled: $setup.loadingSimulatorUscita,
                  class: "btn_simula_presenza"
                }, " Uscita ", 8, ["disabled"])
              ])
            ]),
            ($setup.output && $setup.output.length != 0)
              ? (_openBlock(), _createBlock("div", _hoisted_29, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.output, (record, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: ["single_output", { presenza_error: record.result === 'error' }]
                    }, [
                      _createVNode("div", null, _toDisplayString(record.time) + " - " + _toDisplayString(record.type), 1),
                      _createVNode("div", null, _toDisplayString(record.text), 1)
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})